rebru.functions = function() {

    /**
     * Check if parameter is an object
     * @param element
     * @returns {boolean}
     */
    var isObject = function(element) {
        return (typeof element == 'object' && element instanceof Object && !(element instanceof Array)) ? true : false ;
    }

    /**
     * Pulsate an element
     * @param element
     * @param config
     * @param withScroll
     */
    var pulsate = function(element, config, withScroll=true) {

        /* Scroll wenn aktiviert */
        if(withScroll) {
            var containerOffset = $(element).closest('.rebru-modal').offset().top + 100;
            $(element).closest('.rebru-modal').animate({scrollTop: $(element).offset().top - containerOffset}, 1000);
        }

        /* pulsate Config */
        var defaultConfig = function () {
            return {
                color: '#ff0000', // set the color of the pulse
                reach: 10,                              // how far the pulse goes in px
                speed: 750,          // how long one pulse takes in ms
                pause: 250,             // how long the pause between pulses is in ms
                glow: true,           // if the glow should be shown too
                repeat: true,         // will repeat forever if true, if given a number will repeat for that many times
                onHover: false        // if true only pulsate if user hovers over the element
            }
        }
        var pulsateConfig = $.extend(defaultConfig(),config);
        $(element).pulsate(pulsateConfig);
    }

    /**
     * Refresh a single container
     * @param url string|object
     * @param container jquery selector as string|jquery selectors as array
     * @param params object
     * @param method post|get
     * @param callback function
     */
    var refresh = function(url, container, params, method, callback) {

        if(isObject(url)) {
            if(Array.isArray(container)){
                container.forEach((item) => replace(url, item));
            }else if(typeof container === 'string'){
                replace(url, container);
            }
        } else {
            method = (method === void 0) ? 'get' : 'post';
            $.ajax({
                url: url,
                method: method,
                data: params,
                success: function (data) {
                    if(Array.isArray(container)){
                        container.forEach((item) => replace($(data), item, function() {
                            callback && callback();
                        }));
                    }else if(typeof container === 'string'){
                        replace($(data), container, function() {
                            callback && callback();
                        });
                    }
                }
            });
        }
    }

    /**
     * Replacement of multiple Containers with source
     * @param source
     * @param container
     * @param callback
     */
    var replace = function(source, container, callback)
    {
        if(!isObject(source)) {
            $.ajax({
                url: source,
                success: function(data) {
                    source = data;
                }
            })
        }

        if(Array.isArray(container)) {
            for(i in container) {
                $('' + container[i]).replaceWith(source.find('' + container[i]));
            }
        } else {
            $('' + container).replaceWith($(source).find('' + container));
        }

        if(typeof callback != 'undefined') {
            callback();
        }
    }

    /**
     * Prüft ob noch offene Modals vorhanden sind, und added noscroll Policy zum body hinzu
     */
    var checkModal = function()
    {
        var existing = $('#modalContainer > div').length;
        if(existing > 0) {
            if(!$('body').hasClass('noscroll')) {
                $('body').addClass('noscroll');
                $('footer').css('display','none');
            }
        } else {
            $('body').removeClass('noscroll');
            $('footer').css('display','block');
        }
    }

    /**
     *
     * @param url
     * @param params
     * @param type
     * @param callback
     */
    var loadModal = function(url, params, type, callback)
    {
        rebru.vars.global.scrollPos = $(document).scrollTop();
        rebru.vars.global.scrollPositions.push($(document).scrollTop());

        if(params === void 0) { params = {}; }
        if(type === null) { type = 'get'; }
        $.ajax({
            url: url,
            type: type,
            data: params,
            beforeSend: function() {
                App.blockUI('body', {});
            },
            error:function(jqXHR, textSTatus, errorThrown) {
                App.unblockUI('body', {});
                errorHandler(jqXHR.status);

            },
            success: function(data) {
                if(rebru.functions.isOBject(data)) {
                    if (data.status) {
                        rebru.toastr.publish('success', data.message);
                        if(config.callbacksuccess !== void 0) config.callbacksuccess(data);
                    } else {
                        rebru.toastr.publish('error', data.message);
                    }
                } else {
                    $('#modalContainer').append(data);
                }

            },
            complete: function() {
                App.unblockUI('body', {});
                checkModal();
                if(callback !== void 0) {
                    callback();
                }
            }
        });
    }

    /**
     * Schliesst ein Modal anhand des übergebenen Parameter
     * @param el
     */
    var closeModal = function(el)
    {
        var lastScrollPos = rebru.vars.global.scrollPositions.length -1 ;
        $('html,body').animate({
            scrollTop: rebru.vars.global.scrollPositions[lastScrollPos]
        });
        rebru.vars.global.scrollPositions.pop();
        if($(el).hasClass('modal')) {
            $(el).modal('hide');
            $(el).parent().remove();
            $('.modal-backdrop').remove();
        } else {
            if($(el).closest('.modal').length) {
                $('[data-toggle="tooltip"]',$(el).closest('.modal')).tooltip('dispose');
                $(el).closest('.modal').modal('hide');
                $(el).closest('.modal').parent().remove();
                $('.modal-backdrop').remove();
            }
            if($(el).closest('.rebru-modal').length) {
                $('[data-toggle="tooltip"]',$(el).closest('.rebru-modal')).tooltip('dispose');
                $(el).closest('.rebru-modal').hide({
                    duration:  250,
                    done: function() {
                        $(el).closest('.rebru-modal').remove();
                        checkModal();
                    }
                });
            }
        }
    }

    /**
     * Leert den Content des übergebenen Elements
     * @param el
     */
    var closeModContainer = function(el)
    {
        $('[data-toggle="tooltip"]', $(el)).tooltip('dispose');
        $(el).html('');
    }

    /**
     *
     * @param url
     * @param container
     * @param params
     * @param method
     * @param historyUrl
     */
    var loadContent = function(url, container, params, method, historyUrl) {
        if(isObject(url)) {
            $(''+container).html(url);
        } else {
            method = (method === void 0) ? 'get' : 'post';
            $.ajax({
                url: url,
                method: method,
                data: params,
                error: function(jqXHR, textStatus, errorThrown) {
                    errorHandler(jqXHR.status);
                    $('#modalContainer .modal, #modalContainer .rebru-modal').each(function() {
                        closeModal($(this));
                    });
                },
                beforeSend:function() {
                    App.blockUI('body', {});
                },
                success: function (data) {
                    if(rebru.functions.isOBject(data)) {
                        if (data.status) {
                            swal.fire({
                                title: Translator.trans('success.name'),
                                text: data.message,
                                icon: "success"
                            })
                        } else {
                            swal.fire({
                                title: Translator.trans('error.name'),
                                text: Translator.trans('accessdenied.name'),
                                icon: "error"
                            });
                        }
                    } else {
                        $(''+container).html(data);
                    }

                },
                complete: function() {
                    App.unblockUI('body');
                    if(historyUrl) {
                        history.pushState({}, null, url);
                    }
                }
            });
        }
    }

    /**
     * Beendet die Impersonation
     */
    var exitImpersonation = function()
    {
        $.ajax({
            url: '?_switch_user=_exit',
            success:function(data) {
                window.close();
            }
        });
    }

    /**
     * Creates multicolumn form - should be divided against 12 (1,2,3,4,6)
     * @param form
     * @param containerAnzahl
     */
    var multicolumnForm = function(form, containerAnzahl) {
        var runner = 1;
        var colLength = 12 / containerAnzahl;
        var containerHolder = $('<div class="row" id="holder_'+form+'"></div>');
        for(i=1;i<=containerAnzahl;i++) {
            containerHolder.append('<div class="col-lg-'+colLength+' container'+i+'"></div>');
        }
        containerHolder.insertAfter('#'+form);
        $('#'+form+' > div').each(function() {
            var target = $('#holder_'+form+' .container'+runner);
            $(this).appendTo(target);
            if(runner == containerAnzahl) { runner = 1; } else { runner += 1; }
        });
    }

    /**
     * Speichert den Status eines DetailContainers
     * Container ist ein Selektor im data-attr-containerId (Bsp: #meinContainer)
     * @param element
     * @param callback
     */
    var detailToggler = function(element, callback)
    {
        var containerId = $(element).attr('data-attr-containerId');
        var target = $(containerId);

        target.toggle('blind',null,1000, function() {
            var isVisible = target.is(':visible');
            $(element).find('i').attr('class', ( (isVisible) ? 'la la-search-minus' : 'la la-search-plus' ));
            localStorage.setItem(containerId, isVisible);
            if(typeof callback !== "undefined" && typeof callback == "function") {
                callback();
            }
        });
    }

    /**
     *
     * @param httpCode
     */
    var errorHandler = function(httpCode)
    {
        switch(httpCode)
        {
            case 403:
                swal.fire({
                    title: Translator.trans('error.name'),
                    text: Translator.trans('accessdenied.name'),
                    icon: "error"
                });
                break;

            case 500:
                swal.fire({
                    title: Translator.trans('error.name'),
                    text: Translator.trans('internalerror.name'),
                    icon: "error"
                });
                break;
        }
    }

    function checkFormCollision(selector)
    {
        var collision = false;
        $(''+selector).each(function() {
            if(
                $(''+$(this).attr('data-attr-switch')).prop('checked')
                && $(this).attr('data-error')=="1"
            ) {
                collision = true;
            }
        });

        return collision;
    }

    /**
     * @param optConfig
     */
    function saveForm(optConfig)
    {
        var defaultConfig = {
            url: '',
            type: 'post',
            data: {},
            container: '',
            callbacksuccess: function() {},
            callbacksuccessfailed: function() {}
        }
        var config = $.extend(defaultConfig,optConfig);
        $.ajax({
            url: config.url,
            type: config.type,
            data: config.data,
            beforeSend: function() {
                App.blockUI('body', {});
            },
            error:function(jqXHR, textSTatus, errorThrown) {
                rebru.functions.errorHandler(jqXHR.status);
                App.unblockUI('body', {});
            },
            success: function(data) {
                if(rebru.functions.isOBject(data)) {
                    if (data.status) {
                        rebru.toastr.publish('success', data.message);
                        if(config.callbacksuccess !== void 0) config.callbacksuccess(data);
                    } else {
                        rebru.toastr.publish('error', data.message);
                    }
                } else {
                    $(''+config.container).replaceWith($(data).find(''+config.container));
                    if(config.callbacksuccessfailed !== void 0) config.callbacksuccessfailed();
                }

            },
            complete: function() {
                App.unblockUI('body', {});
                rebru.functions.checkModal();
                if(config.callbackcomplete !== void 0) {
                    config.callbackcomplete();
                }
            }
        });
    }

    /**
     *
     * @param url
     * @param params
     * @param type
     * @param targetObject
     */
    function loadDetailWithPulsate(url, params, type, targetObject)
    {
        rebru.functions.loadModal(url, null, null, function() {
            setTimeout( function() {
                rebru.functions.pulsate($(targetObject));
            },2000 );
        });
    }

    /**
     *
     * @param searchparam element
     * @param table element
     * @param elementToSearch number
     */
    function tableSearch(searchparam, table, elementToSearch) {
        $(''+searchparam).on('keypress', function(e) {
            if(e.keyCode == 13) {
                var searchstring = $(this).val();

                $(table+' tbody tr td:nth-child('+elementToSearch+')').each(function () {
                    var text = " " + $(this).text().trim().toLowerCase();
                    if (text.search(searchstring.toLowerCase()) >= 0) {
                        $(this).parent().show();
                    } else {
                        $(this).parent().hide();
                    }
                });
            }
        });

        $(''+searchparam).siblings('div').find('button').on('click', function(){
            $(''+searchparam).val('');
            let enter = $.Event('keypress', {keyCode: 13});
            $(''+searchparam).trigger(enter);
        })
    }

    return {
        init: function(config) {
            elements(config);
        },
        preventSubmit : function(element) {
            $(element).bind('keypress keydown keyup', function(e){
                if(e.keyCode == 13) { e.preventDefault(); }
            });
        },
        refresh: function(url, container, params, method, callback) {
            refresh(url, container, params, method, callback);
        },
        replace: function(url, container, callback) {
            replace(url, container, callback);
        },
        loadModal: function(url, params,type, callback) {
            loadModal(url,params,type, callback);
        },
        closeModal: function(element) {
            closeModal(element);
        },
        closeModContainer: function(element) {
            closeModContainer(element);
        },
        checkModal: function() {
            checkModal();
        },
        loadContent: function(url, container, params, method, historyUrl) {
            loadContent(url, container, params, method, historyUrl);
        },
        loadTabDetails: function(element, container, historyUrl) {
            if($(element).attr('data-attr-url')) {
                var url = $(element).attr('data-attr-url');

                loadContent(url, container);
            }
            if(historyUrl) {
                history.pushState({}, null, historyUrl);
            }
        },
        isOBject: function(element) {
            return isObject(element);
        },
        exitImpersonation: function() {
            exitImpersonation();
        },
        multicolumnForm: function(form, containerAnzahl) {
            multicolumnForm(form, containerAnzahl);
        },
        pulsate: function(element, config) {
            pulsate(element, config);
        },
        errorHandler: function(httpCode) {
            errorHandler(httpCode);
        },
        checkFormCollision: function(selector) {
            return checkFormCollision(selector);
        },
        saveForm: function(optConfig) {
            saveForm(optConfig);
        },
        loadDetailWithPulsate: function(url, params, type, targetObject) {
            loadDetailWithPulsate(url, params, type, targetObject)
        },
        tableSearch: function(searchparam, table, elementToSearch) {
            tableSearch(searchparam, table, elementToSearch)
        }
    }
}();
